import { Controller } from '@hotwired/stimulus';
import CurrentUser from '@frontend/app/features/CurrentUser';
import CurrentPage from '@frontend/app/features/CurrentPage';
import { loadAndDisplay as loadAndDisplayInModal } from '@controllers/main/modal-window_controller';
import {
  apply as applyQueryParams,
  extract as extractQueryParams,
} from '@frontend/utils/query-params';
import { dispatchCustomEvent } from '@frontend/utils/events';

export default class extends Controller {
  static targets = ['bookmarkIcon', 'shareUrl'];
  static values = {
    articleId: Number,
    ebookModalUrl: String,
  };
  static classes = ['bookmarkIconActive', 'bookmarkIconInactive', 'hidden'];

  connect() {
    this.updateBookmarkDisplay();
    this.updateArticleUrlWithSharedParam();
    this.notifyFinished();

    this.element.addEventListener(
      'ajax:complete',
      this.updateBookmarkDisplay.bind(this)
    );
    document.body.addEventListener('article-actions:hide', this.hide.bind(this));
    document.body.addEventListener('article-actions:show', this.show.bind(this));
  }

  disconnect() {
    document.body.removeEventListener('article-actions:hide', this.hide.bind(this));
    document.body.removeEventListener('article-actions:show', this.show.bind(this));
  }

  notifyFinished() {
    document
      .querySelector('html')
      .classList.add('js-test-article-actions-finished');
  }

  show() {
    this.element.classList.remove(this.hiddenClass);
  }

  hide() {
    this.element.classList.add(this.hiddenClass);
  }

  updateBookmarkDisplay() {
    const isBookmarked = CurrentUser.bookmarks().includes(this.articleIdValue);

    this.setBookmarkIconState(isBookmarked);
    this.element.dataset.testArticleBookmarkIsActive = isBookmarked;
  }

  updateArticleUrlWithSharedParam() {
    if (!this.hasShareUrlTarget) {
      return false;
    }

    const urlParams = new URLSearchParams(window.location.search);
    if (['preview', 'shared'].every((param) => !urlParams.has(param))) {
      let newUrl = applyQueryParams(
        CurrentPage.getUrl(),
        extractQueryParams(this.shareUrlTarget.href)
      );

      if (window.location.hash.length > 0) {
        newUrl = newUrl + window.location.hash;
      }

      window.history.replaceState({}, '', newUrl);
    }
  }

  setBookmarkIconState(isActive) {
    this.bookmarkIconTarget.classList.toggle(
      this.bookmarkIconActiveClass,
      isActive
    );
    this.bookmarkIconTarget.classList.toggle(
      this.bookmarkIconInactiveClass,
      !isActive
    );
  }

  showEbookDownloadModal(event) {
    event.preventDefault();

    loadAndDisplayInModal(this.ebookModalUrlValue);
  }
}

export function hide() {
  dispatchCustomEvent('article-actions:hide');
}

export function show() {
  dispatchCustomEvent('article-actions:show');
}
